import React from "react";
import { siteContent } from "../content";
import Section from "../components/Section";
import ContactForm from "../components/ContactForm";
import SocialIcons from "../components/SocialIcons";

export default function Contact() {
  const { contact, socials, brand } = siteContent;

  return (
    <div className="space-y-6">
      <Section
        eyebrow="Contact"
        title="Bookings & enquiries"
        description="For live concerts, playback singing, and virtual shows."
      >
        <div className="grid gap-6 md:grid-cols-2">
          <div className="rounded-3xl border border-white/10 bg-gradient-to-br from-amber-300/10 via-white/5 to-purple-500/10 p-6 shadow-2xl space-y-4">
            <p className="text-sm uppercase tracking-[0.2em] text-amber-200/80">
              {brand.name}
            </p>
            <h3 className="text-2xl font-extrabold text-white">
              {brand.primaryCta}
            </h3>
            <div className="space-y-3 text-gray-200">
              <a
                href={contact.whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="block rounded-2xl bg-green-500 text-white font-semibold px-4 py-3 text-center shadow-lg hover:shadow-green-500/30 transition"
              >
                WhatsApp: {contact.whatsapp}
              </a>
              <a
                href={`mailto:${contact.email}`}
                className="block rounded-2xl bg-white/10 border border-white/10 text-white font-semibold px-4 py-3 text-center hover:bg-white/15 transition"
              >
                {contact.email}
              </a>
              <p className="text-sm text-gray-300">
                Connect with us for festivals, weddings, community events, and corporate shows.
              </p>
            </div>
            <SocialIcons socials={socials} />
          </div>

          <ContactForm />
        </div>
      </Section>
    </div>
  );
}
